import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService, ErrorsService, ThirdpartySystemResourceTypeFields} from 'shared';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class ThirdpartySystemService {

  constructor(private http: HttpClient, private config: ConfigService, errors: ErrorsService) {
  }

  fields(resourceType: string): Observable<ThirdpartySystemResourceTypeFields[]> {
    return this.http.get<ThirdpartySystemResourceTypeFields[]>(
      this.config.apiVerUrl(`/app/thirdparty-systems/${resourceType}/fields`)
    ).pipe(
      map((d) => {
        return d.map(e => new ThirdpartySystemResourceTypeFields(e));
      })
    );
  }

  checkUnique(resourceType: string, req: { system: string; field: string; value: any; id?: number }): Observable<boolean> {
    return this.http.post<boolean>(this.config.apiVerUrl(`/app/thirdparty-systems/${resourceType}/check-unique`), req);
  }
}
